import { POWER_ZERO } from '../constants.js';

/**
 * Some lenses, such as costume and Halloween lenses, can be sold "without a prescription".
 * In reality, they still have power, base curve and diameter prescription values.
 *
 * In the UI, we can choose to either:
 * - show the Rx entry fields and require the user to fill them in or
 * - hide the Rx entry fields and assume default values for power, base curve and diameter or
 * - allow the user to either enter in a chosen power value, or add to cart with only defaults, if they want
 *
 * When adding a default value for power, it is always set to '0.00'
 */ const getRxEntryType = (sortedAttributesSet)=>{
    const restRxCLPrescriptionValues = sortedAttributesSet.filter((i)=>i.name !== 'power' && i.name !== 'baseCurve' && i.name !== 'diameter'
    );
    const diameterOrBaseCurve = sortedAttributesSet.filter((i)=>i.name === 'baseCurve' || i.name === 'diameter'
    );
    const power = sortedAttributesSet.find((i)=>i.name === 'power'
    );
    const powerOptions = power ? Object.keys(power.attributeOptions) : [];
    // If there are any Rx fields besides power, base curve and diameter, Rx entry is required
    if (restRxCLPrescriptionValues.length) {
        return 'rx-entry-required';
    }
    // If there are multiple options for base curve or diameter, Rx entry is required
    if (diameterOrBaseCurve.some((i)=>Object.keys(i.attributeOptions).length > 1
    )) {
        return 'rx-entry-required';
    }
    // If there is only one option for power and it is 0.00, Rx entry is not required
    if (powerOptions.length === 1 && powerOptions[0] === POWER_ZERO) {
        return 'no-rx-entry';
    }
    // If there are multiple options for power and one of them is 0.00, Rx entry is optional
    if (powerOptions.length > 1 && powerOptions.includes(POWER_ZERO)) {
        return 'rx-entry-optional';
    }
    return 'rx-entry-required';
};

export { getRxEntryType };
//# sourceMappingURL=get-rx-entry-type.js.map
